<template>
  <div class="modal" @mousedown="closeModal">
    <div class="card" style="max-width: 550px">
      <div class="card-header">
        <h1>Practice Name List</h1>
        <p>Register alternative names for your practice so that they can be sent in your intake message.</p>
      </div>
      <div class="card-body">
        <div class="name-list">
          <div class="name-list-item">
            <img src="@/assets/name.png" alt="Name Icon" class="name-icon">
            <span>{{ store.account.name }}</span>
          </div>
          <div class="name-list-item" v-for="(_, idx) of names" :key="idx">
            <img src="@/assets/name.png" alt="Name Icon" class="name-icon">
            <input ref="inputs" type="text" v-model="names[idx]" @blur="handleBlur">
          </div>
          <div class="name-list-item">
            <img src="@/assets/name.png" alt="Name Icon" class="name-icon">
            <input type="text" @keydown.prevent.stop="handleKeyDown" placeholder="Register a new name">
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button class="button primary" @click.prevent="attemptSaveChanges">
          <img src="/loading.svg" alt="Loading" class="loading" v-if="isPending">
          <span v-else>Save Changes</span>
        </button>
        <p class="error" v-if="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { setAlternativeNames, store } from '../../api'

export default {
  name: "PracticeNameList",
  data() {
    return {
      store,
      names: store.account.alternativeNames,
      error: '',
      isPending: false
    }
  },
  methods: {
    async attemptSaveChanges() {
      if (this.isPending) return;

      try {
        this.isPending = true;
        await setAlternativeNames(this.names);
        this.$emit('closeModal');

      } catch (err) {
        this.error = err.message;
        console.error(err);
      } finally {
        this.isPending = false;
      }
    },
    closeModal(event) {
      if (event.target.className != "modal") {
        return;
      }
      this.$emit("closeModal");
    },
    handleBlur() {
      this.names = this.names.filter(name => {
        return name.length > 0
      })
    },
    handleKeyDown(event) {
      if (event.key.length > 1) {
        return;
      }

      this.names.push(event.key);

      this.$nextTick(() => {
        const inputRefs = this.$refs.inputs;
        const lastInput = inputRefs[inputRefs.length - 1];
        lastInput.focus();
      })
    }
  },
  emits: ["closeModal", "openModal"],
};
</script>

<style scoped>
.name-list-item {
  width: 100%;
  padding: 10px;
  height: 52px;
  border-radius: 5px;
  box-shadow: 0px 0px 4px #00000022;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.name-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.name-icon {
  display: block;
  height: 24px;
  margin-right: 10px;
}

.card-body .icon-sm {
  display: block;
  height: 32px;
  filter: saturate(0);
}

.icon-sm:hover {
  cursor: pointer;
  filter: none;
}

input {
  flex: 1;
  font-size: 16px;
  border: none;
  background: none;
  outline: none;
}

input::placeholder {
  opacity: 0.3;
}
</style>